import React from "react";
import { Container, Image, Jumbotron } from "react-bootstrap";
import { updateTextStyles } from "../Services/FormatMenu";

export const Restaurant = ({ restaurantData }) => {
  const {
    name,
    introduction,
    displayDate,
    logoUrl,
    publishedDate,
    backgroundImageUrl,
    restaurantNameStyle,
    descriptionTextStyle,
    dateTextStyle,
  } = restaurantData;

  const defaultRestaurantStyle = {
    color: "#fff",
    fontFamily: "Libre Baskerville",
    format: "woff",
  };

  const newTimer = new Date().getTime();

  return (
    <header role="banner" aria-label="banner">
      <Jumbotron
        fluid
        align="center"
        className="mb-1"
        style={{
          ...(backgroundImageUrl && {
            backgroundImage: `url(${
              backgroundImageUrl + "?nocache=" + newTimer
            })`,
            backgroundRepeat: "no-repeat",
          }),
        }}
      >
        <Container className="text-center">
          {logoUrl && (
            <Image
              width={86}
              src={logoUrl + "?nocache=" + newTimer}
              alt={name}
            />
          )}
          <h1
            className="mt-3 baskerville-bold"
            style={{
              ...defaultRestaurantStyle,
              ...updateTextStyles(restaurantNameStyle),
            }}
            aria-label={name}
          >
            {name}
          </h1>
          <p
            style={{
              ...defaultRestaurantStyle,
              ...updateTextStyles(descriptionTextStyle),
              whiteSpace: "pre-wrap",
            }}
            aria-label="Restaurant introduction"
          >
            {introduction}
          </p>
          <span aria-label="Menu published date">
            {displayDate && (
              <p
                style={{
                  fontSize: "12px",
                  ...defaultRestaurantStyle,
                  ...updateTextStyles(dateTextStyle),
                }}
              >
                {publishedDate}
              </p>
            )}
          </span>
        </Container>
      </Jumbotron>
    </header>
  );
};

export default Restaurant;
